import React from 'react';
import { cn } from '@/lib/utils';

export const Card = ({ children, className, title, ...props }) => {
  return (
    <div 
      className={cn(
        'rounded-xl border transition-colors',
        'bg-[var(--surface)] border-[var(--border)]',
        'shadow-[0_1px_2px_0_rgba(0,0,0,0.04)] dark:shadow-none',
        className
      )}
      {...props}
    >
      {title && (
        <div className="px-6 py-4 border-b border-[var(--border)]">
          <h3 className="text-base font-medium tracking-tight text-[var(--text-primary)]">{title}</h3>
        </div>
      )}
      <div className={cn(title ? 'p-6' : 'p-6')}>
        {children}
      </div>
    </div>
  );
};
